<div class="modal-content">
  <div class="modal-header">
    <div class="pb-4">
      <i aria-label="Close" (click)="handleClick()" class="close pull-right align-middle fas fa-times"> </i>
    </div>
    <h4 jhiTranslate="baryApp.how-to.upload-acceptance.title"></h4>
  </div>
  <div class="mt-3 alert alert-info">
    <p jhiTranslate="baryApp.how-to.upload-acceptance.intro"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.file"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.format"></p>
    <ul>
      <li jhiTranslate="baryApp.how-to.upload-acceptance.column1"></li>
      <li jhiTranslate="baryApp.how-to.upload-acceptance.column2"></li>
      <li jhiTranslate="baryApp.how-to.upload-acceptance.column3"></li>
      <li jhiTranslate="baryApp.how-to.upload-acceptance.column4"></li>
      <li jhiTranslate="baryApp.how-to.upload-acceptance.column5"></li>
    </ul>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.sheets"></p>
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-acceptance.sample"></span>
    </div>
    <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.acceptance"></th>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>FR</td>
        <td>75000</td>
        <th>1</th>
      </tr>
      <tr>
        <td>FR</td>
        <td>75000</td>
        <td>FR</td>
        <td>33700</td>
        <th>1</th>
      </tr>
    </table>
    <br />
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-acceptance.priority"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.rules"></p>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.algorithm"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.flatZipCode"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.p1"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.wildCardRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.p2"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.startRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.p3"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.rangeRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.p4"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.pipeRule"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.p5"></p>
    <div class="h5">
      <span jhiTranslate="baryApp.how-to.upload-acceptance.score"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.scoreDetails"></p>
    <br />
    <div class="h5">
      <jhi-bary-icon icon="info-circle" [faDirective]="FAS" class="info-text pr-2" aria-hidden="true"></jhi-bary-icon>
      <span jhiTranslate="baryApp.how-to.upload-acceptance.sampleRules"></span>
    </div>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.sampleRules1"></p>
    <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.acceptance"></th>
      </tr>
      <tr>
        <td>FR</td>
        <td>#337</td>
        <td>FR</td>
        <td>#33</td>
        <td>2</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>FR</td>
        <td>#33</td>
        <td>2</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>FR</td>
        <td>33000</td>
        <td>1</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33***</td>
        <td>FR</td>
        <td>75***</td>
        <td>1</td>
      </tr>
    </table>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.sampleRules2"></p>
    <table mdbTable [hover]="false" [small]="true" class="table-responsive bg-white">
      <tr class="bg-main">
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeDeparture"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.countryArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.zipCodeArrival"></th>
        <th jhiTranslate="baryApp.how-to.upload-acceptance.tab.acceptance"></th>
        <th class="bg-info">Score</th>
      </tr>
      <tr>
        <td>FR</td>
        <td>#337</td>
        <td>FR</td>
        <td>#33</td>
        <td>2</td>
        <td class="bg-info">3+2=5</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>FR</td>
        <td>#33</td>
        <td>2</td>
        <td class="bg-info">5+2=7</td>
      </tr>
      <tr>
        <td>FR</td>
        <td>33700</td>
        <td>FR</td>
        <td>33000</td>
        <td>1</td>
        <td class="bg-info">5+5=10</td>
      </tr>
    </table>
    <p jhiTranslate="baryApp.how-to.upload-acceptance.sampleRules3"></p>
  </div>
</div>
